import { render, staticRenderFns } from "./ComplexPolynomialViz.vue?vue&type=template&id=2a496394&scoped=true"
import script from "./ComplexPolynomialViz.vue?vue&type=script&lang=js"
export * from "./ComplexPolynomialViz.vue?vue&type=script&lang=js"
import style0 from "./ComplexPolynomialViz.vue?vue&type=style&index=0&id=2a496394&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a496394",
  null
  
)

export default component.exports